import { amplitude } from '@loggi/analytics';
import { applyMiddleware, createStore } from 'redux';
import reduxImmutableStateInvariant from 'redux-immutable-state-invariant';
import thunk from 'redux-thunk';
import rootReducer from '../reducers';
import amplitudeMapper from './middlewares/amplitude';

const amplitudeMiddleware = amplitude.middleware(amplitudeMapper);
const middleware = [thunk, amplitudeMiddleware];

// eslint-disable-next-line no-undef
if (__DEV__) {
  middleware.push(reduxImmutableStateInvariant());
}

export default function configureStore(initialState) {
  return createStore(rootReducer, initialState, applyMiddleware(...middleware));
}
